import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "./assets/base.less"

// 移动端样式框架
import 'vant/lib/index.css';
import "./plugin/vant"

// PC端样式框架
import 'element-ui/lib/theme-chalk/index.css'
import './plugin/element'

// 进度条样式
import 'nprogress/nprogress.css'

import FastClick from 'fastclick'

// 事件总线
Vue.prototype.$bus = new Vue()

// 解决移动端300毫秒延迟
FastClick.attach(document.body)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
